<template>
  <div>
    <h1 class="display-1 primary--text">
      {{ $t('message.average_values_title') }}
    </h1>

    <v-container
      id="avgList"
      fluid
      grid-list-md
    >
      <v-data-iterator
        :items="averageValues.data"
        content-tag="v-layout"
        hide-actions
        row
        wrap
      >
        <template v-slot:item="row">
          <v-flex xs12>
            <v-card>
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>
                    <h3>
                      {{ row.item.date | formatDate }}
                    </h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{ $t('message.current') }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{ $t('message.target') }}
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    {{ $t('message.average_val_actualLifeBalance') }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{
                      formattedValue(row.item.current.actualLifeBalance, 0, '€')
                    }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{
                      formattedValue(row.item.target.actualLifeBalance, 0, '€')
                    }}
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    {{ $t('message.average_val_lifeBalance') }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{ formattedValue(row.item.current.lifeBalance, 0, '€') }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{ formattedValue(row.item.target.lifeBalance, 0, '€') }}
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    {{ $t('message.average_val_rollingAnualAvgProduction') }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{
                      formattedValue(row.item.current.rollingAnualAvgProduction)
                    }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{
                      formattedValue(row.item.target.rollingAnualAvgProduction)
                    }}
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    {{ $t('message.average_val_avgHerdLifePerCow') }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{ formattedValue(row.item.current.avgHerdLifePerCow, 2) }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{ formattedValue(row.item.target.avgHerdLifePerCow, 2) }}
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    {{ $t('message.average_val_productiveLifespan') }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{ formattedValue(row.item.current.productiveLifespan, 2) }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{ formattedValue(row.item.target.productiveLifespan, 2) }}
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    {{ $t('message.average_val_lifelongProductionPerCow') }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{
                      formattedValue(row.item.current.lifelongProductionPerCow)
                    }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{
                      formattedValue(row.item.target.lifelongProductionPerCow)
                    }}
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    {{ $t('message.average_val_lifespanCulling') }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{ formattedValue(row.item.current.lifespanCulling, 2) }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{ formattedValue(row.item.target.lifespanCulling, 2) }}
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    {{ $t('message.average_val_productiveLifespanCulling') }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{
                      formattedValue(
                        row.item.current.productiveLifespanCulling,
                        2
                      )
                    }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{
                      formattedValue(
                        row.item.target.productiveLifespanCulling,
                        2
                      )
                    }}
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    {{ $t('message.average_val_lifespanProduction') }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{ formattedValue(row.item.current.lifespanProduction) }}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    {{ formattedValue(row.item.target.lifespanProduction) }}
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </template>
      </v-data-iterator>
    </v-container>

    <v-dialog
      v-model="dialog"
      max-width="700px"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="secondary"
          fab
          fixed
          bottom
          right
          dark
          class="mb-4"
          v-on="on"
        >
          <v-icon dark>
            add
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('message.add_average_value') }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="averageValue.date"
                      :label="$t('message.average_val_date')"
                      prepend-inner-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="averageValue.date"
                    @input="dateMenu = false"
                  />
                </v-menu>
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.current.actualLifeBalance"
                  :label="$t('message.average_val_actualLifeBalance')"
                  prefix="€"
                  :hint="$t('message.current')"
                  persistent-hint
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.target.actualLifeBalance"
                  :label="$t('message.average_val_actualLifeBalance')"
                  prefix="€"
                  :hint="$t('message.target')"
                  persistent-hint
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.current.lifeBalance"
                  :label="$t('message.average_val_lifeBalance')"
                  prefix="€"
                  :hint="$t('message.current')"
                  persistent-hint
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.target.lifeBalance"
                  :label="$t('message.average_val_lifeBalance')"
                  prefix="€"
                  :hint="$t('message.target')"
                  persistent-hint
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="
                    averageValue.current.rollingAnualAvgProduction
                  "
                  :label="$t('message.average_val_rollingAnualAvgProduction')"
                  :hint="$t('message.current')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.target.rollingAnualAvgProduction"
                  :label="$t('message.average_val_rollingAnualAvgProduction')"
                  :hint="$t('message.target')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.current.avgHerdLifePerCow"
                  :label="$t('message.average_val_avgHerdLifePerCow')"
                  :hint="$t('message.current')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.target.avgHerdLifePerCow"
                  :label="$t('message.average_val_avgHerdLifePerCow')"
                  :hint="$t('message.target')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.current.productiveLifespan"
                  :label="$t('message.average_val_productiveLifespan')"
                  :hint="$t('message.current')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.target.productiveLifespan"
                  :label="$t('message.average_val_productiveLifespan')"
                  :hint="$t('message.target')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.current.lifelongProductionPerCow"
                  :label="$t('message.average_val_lifelongProductionPerCow')"
                  :hint="$t('message.current')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.target.lifelongProductionPerCow"
                  :label="$t('message.average_val_lifelongProductionPerCow')"
                  :hint="$t('message.target')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.current.lifespanCulling"
                  :label="$t('message.average_val_lifespanCulling')"
                  :hint="$t('message.current')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.target.lifespanCulling"
                  :label="$t('message.average_val_lifespanCulling')"
                  :hint="$t('message.target')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="
                    averageValue.current.productiveLifespanCulling
                  "
                  :label="$t('message.average_val_productiveLifespanCulling')"
                  :hint="$t('message.current')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.target.productiveLifespanCulling"
                  :label="$t('message.average_val_productiveLifespanCulling')"
                  :hint="$t('message.target')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.current.lifespanProduction"
                  :label="$t('message.average_val_lifespanProduction')"
                  :hint="$t('message.current')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model.number="averageValue.target.lifespanProduction"
                  :label="$t('message.average_val_lifespanProduction')"
                  :hint="$t('message.target')"
                  persistent-hint
                  prefix=" "
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="darken-1"
            flat
            @click="closeDialog"
          >
            {{ $t('message.close') }}
          </v-btn>
          <v-btn
            color="secondary"
            @click="save"
          >
            {{ $t('message.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'Targets',
  data: (vm) => ({
    dialog: false,
    fields: [
      'actualLifeBalance',
      'lifeBalance',
      'rollingAnualAvgProduction',
      'avgHerdLifePerCow',
      'productiveLifespan',
      'lifelongProductionPerCow',
      'lifespanCulling',
      'productiveLifespanCulling',
      'lifespanProduction',
    ],
    editedIndex: -1,
    averageValue: {
      date: new Date().toISOString().substr(0, 10),
      current: {},
      target: {},
    },
    dateMenu: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: -1, // -1 for All",
      sortBy: 'date',
    },
  }),
  computed: {
    ...mapState(['averageValues']),
  },
  created() {
    this.$store.dispatch('getAverageValues')
  },
  methods: {
    save: function () {
      // [
      //   'actualLifeBalance'
      //   , 'lifeBalance'
      // ].forEach(key => {
      //   this.averageValue.target[key] = this.averageValue.target[key] * 100
      //   this.averageValue.current[key] = this.averageValue.current[key] * 100
      // }); // ; needed!

      this.$store.dispatch('saveAverageValues', this.averageValue)
      this.closeDialog()
    },
    closeDialog: function () {
      this.dialog = false
      this.averageValue = {
        date: new Date().toISOString().substr(0, 10),
        current: {},
        target: {},
      }
    },
    formattedValue(v, fractionDigits = 0, unit) {
      if (isNaN(v)) return '-'
      else {
        const localizedNum = v.toLocaleString('nl', {
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits,
        })
        return unit ? unit + ' ' + localizedNum : localizedNum
      }
    },
  },
}
</script>
<style lang="less">
#avgList {
  .v-card {
    max-width: 700px;
  }

  .v-list > div {
    border-bottom: 1px dashed silver;
  }

  .v-list--dense .v-list__tile {
    font-size: initial;
  }

  .v-list__tile {
    > div:first-child {
      width: 50%;
    }
    > div:nth-child(2) {
      width: 25%;
    }
    > div:nth-child(3) {
      width: 25%;
    }
  }

  .v-list > div:last-child {
    border: 0;
  }
}
</style>
